export default {
  es: {
    invalidLink: "Enlace inválido",
    invalidLinkDescription: "El enlace que buscas ha expirado o ya no está disponible.",
    btnText: "ACEPTAR",
    validLink: "Gracias por aceptar",
    validLinkDescription: "El proceso ha finalizado. Puedes cerrar esta ventana.",
  },
  en: {
    invalidLink: "Invalid link",
    invalidLinkDescription: "The link you are looking for has expired or is no longer available.",
    btnText: "ACCEPT",
    validLink: "Thank you for accepting",
    validLinkDescription: "The process has been completed. You can close this window.",
  },
};
